export const borderRadius = {
  "sys-none": "0px",
  "sys-xs": "0.125rem",
  "sys-sm": "0.25rem",
  "sys-md": "0.375rem",
  "sys-lg": "0.5rem",
  "sys-xl": "0.625rem",
  "sys-2xl": "0.75rem",
  "sys-3xl": "1rem",
  "sys-4xl": "1.5rem",
  "sys-full": "9999px",
};
